import { Typography, Box } from 'components/Material/index'
import useTextStyles from 'styles/useTextStyles'
import { getIconsGroups } from 'utils/getIconsGroups'

export const CodeTicket = ({ title, nmProduto }: { title: string; nmProduto: string }) => {
  return (
    <Box
      title={title || ''}
      className="flex items-center gap-2 w-44 h-8 p-2 border border-gray-50 rounded-lg"
    >
      {getIconsGroups(nmProduto)}
      <Typography sx={useTextStyles.labelLarge}>{title}</Typography>
    </Box>
  )
}
